module.exports = __webpack_public_path__ + "static/img/banner4.af0c30c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepageComponent/images/banner4.jpg
// module id = 42LJ
// module chunks = 6